import { render, staticRenderFns } from "./ResearchAndInsightsView.vue?vue&type=template&id=f2a885f2&scoped=true"
import script from "./ResearchAndInsightsView.vue?vue&type=script&lang=js"
export * from "./ResearchAndInsightsView.vue?vue&type=script&lang=js"
import style0 from "./ResearchAndInsightsView.vue?vue&type=style&index=0&id=f2a885f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a885f2",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QIcon,QInput,QBtn,QDialog});
